<div class="form" [formGroup]="form()">
  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="address"
    [label]="'withdrawal.crypto.address.label' | translate"
    [placeholder]="'withdrawal.crypto.address.placeholder' | translate"
    [iconTemplate]="infoTmpl"
  />

  <ng-template #infoTmpl>
    <iw-tooltip
      class="ci-details-tooltip"
      [maxWidth]="326"
      position="tc"
      title="withdrawal.crypto.address.tooltip"
    />
  </ng-template>

  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="description"
    [label]="'withdrawal.crypto.details.label' | translate"
    [placeholder]="'withdrawal.crypto.details.placeholder' | translate"
  />
</div>
